import ReportSubsection from "@app/analytics/components/reports/ReportSubsection";

import { Column } from "@rui/Stack";

import BiasModule from "./BiasModule";
import CharismaModule from "./CharismaModule";
import QuestionsAskedModule from "./QuestionsAskedModule";
import {
  Section,
  SectionHeading,
  SectionSubtitle,
  SectionTitle,
} from "./styles";
import type { CoachingSectionProps } from "./types";

const CoachingImpact = ({ onClickMoment }: CoachingSectionProps) => {
  return (
    <ReportSubsection id="impact" sx={{ p: 0, pb: 1 }}>
      <Section>
        <SectionHeading>
          <SectionTitle>Impact</SectionTitle>
          <SectionSubtitle>
            Measures how you are perceived, and how others perceive you
          </SectionSubtitle>
        </SectionHeading>
        <Column>
          <BiasModule />
          <CharismaModule />
          <QuestionsAskedModule onClickMoment={onClickMoment} />
        </Column>
      </Section>
    </ReportSubsection>
  );
};

export default CoachingImpact;
